import script from "./IntangibleAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./IntangibleAssets.vue?vue&type=script&setup=true&lang=js"

import "./IntangibleAssets.vue?vue&type=style&index=0&id=2d952085&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d952085"]])

export default __exports__